<template>
    <div class="layout--full-page auth-wrapper auth-v1 px-2 bg-img">
        <div class="auth-inner py-2" style="max-width: 60%;">
            <b-row class="">
                <b-col>
                    <b-card>
                        <div class="">
                            <b-row class="flex-column justify-content-center">
                                <div style="text-align: center;" class="">
                                    <img class="logo d-none d-lg-inline" src="@/assets/images/logo/logo-signathor.webp" alt="Logo">
                                    <img class="logo-sm d-lg-none" src="@/assets/images/logo/signathor_transparent.webp" alt="Logo">
                                </div>
                                <b-col>
                                    <div class="px-8 pt-2">
                                        <div class="vx-card__title">
                                            <h4 class="mb-1" style="text-align:center;">Invitación</h4>
                                        </div>
                                        <b-tabs align="center" class="">
                                           <b-tab active title="Iniciar Sesión">
                                              <div class="login-tabs-container">
                                                  <loginTemplate :principal=false></loginTemplate>
                                              </div>
                                          </b-tab>
                                          <b-tab title="Registrar">
                                            <register-jwt :principal=false></register-jwt>
                                          </b-tab>
                                        </b-tabs>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import axios from '@/axios';
import RegisterJwt from './RegisterJWT.vue'
import LoginTemplate from './LoginTemplate.vue'
export default {
  components: {
    RegisterJwt,
    LoginTemplate
  },

  methods:{
    verificarInvitacion(){
        axios
        .post('api/invitacion/verificar/',
            {
                token_publico: this.$route.params.token_publico
            }
        )
        .then(response => {
            if (!response.data.data){
                this.$router.push({name: 'page-login-token', params: {token_publico: this.$route.params.token_publico} })
            }
        })
    },
  },

  created() {
      this.verificarInvitacion();
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>

<style lang="scss">
    .register-tabs-container {
      min-height: 517px;

      .con-tab {
        padding-bottom: 23px;
      }
    }
    .logo{
        height: 60px;
        width: 18rem;
    }
    .logo-sm{
        height: 100px;
    }
</style>
